<template>
  <div class="login-content">
    <h2>账号密码登录</h2>
    <div class="tab-content">
      <div class="message-content" >
        <el-input v-model="mobilePhone"  placeholder="请输入帐号"></el-input>
        <el-input v-model="password" placeholder="请输入密码" show-password></el-input>
      </div>
      <el-button type="primary" style="width: 100%; margin-top: 30px" @click="loginPost">登录</el-button>
    </div>
  </div>
</template>

<script>
import {login} from "../utils/login"
const reg = /^1[3456789]\d{9}$/;
export default {
  data() {
    return {
      mobilePhone: "",//手机号
      password: "",//密码
    };
  },
  methods: {
    loginPost() {
      if(!this.mobilePhone){
        this.$message.error("请输入手机号")
        return
      }
      if (!reg.test(this.mobilePhone)) {
        this.$message.error("手机号码格式错误")
        return
      }
      if (!this.password) {
        this.$message.error("请输入密码")
        return
      }
      let data ={
        mobilePhone:this.mobilePhone,
        password:this.password
      }
      login(data).then(res =>{
        if(res.data.code == 200){
          localStorage.setItem('loginstate', JSON.stringify(res.data.data));
          setTimeout(()=>{
            this.$router.push("/");
          },1000)
        }else if(res.data.code == 500){
          this.$message.warning(res.data.data)
        }else{
          this.$message.error("登录失败,请重试")
        }
      })
      // this.$router.push("/");
      // localStorage.setItem('loginstate', JSON.stringify(res.data.data));
    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-button--primary{
  background-color: #4476EF;
  border-color: #4476EF;
}
/deep/ .el-input {
  margin-top: 25px;
}

/deep/ .el-message-box__header {
  padding: 17px 0px 0px 43px !important;
}

/deep/ .el-input__inner {
  font-size: 14px;
  background: #fff !important;
}

.tab-content,
.tab {
  padding: 0 25px;
}
h2{
  color: #4476ef;
  font-weight: 700;
  position: relative;
  font-size: 18px;
}
.tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 27px auto 20px;
  font-size: 18px;

  div {
    width: 50%;
    text-align: center;
    cursor: pointer;

    &.active {
      color: #4476EF;
      font-weight: bold;
      position: relative;

      &::after {
        content: "";
        width: 20px;
        height: 2px;
        background-color: #4476EF;
        position: absolute;
        top: 140%;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.code {
  position: relative;

  span {
    position: absolute;
    right: 10px;
    bottom: 10px;
    color: #4476EF;
    cursor: pointer;
  }
}
</style>